export default __webpack_public_path__ + "static/media/waze.1553c89e.svg";